// src/invoices/print.js — печат на фактура и таблична справка (Фаза 3.2).
// Легаси мост: window.printInvoice (вика се от модула на проформите).

import { el, clear } from '../shared/dom.js';
import { money, dfmt } from '../shared/format.js';
import { state, activeCompanyObj, contacts as contactsCache } from '../shared/state.js';
import { esc, printHTML } from '../protocols/print.js';
// Сумата словом идва от общата услуга — тук се викаше функция, която не
// съществуваше никъде, и целият бутон „Печат" гърмеше (хванато 01.09.2026).
import { amountInWords } from '../../services/amountWords.js';

function _money(n){ n=Math.round((Number(n)||0)*100)/100; var p=n.toFixed(2).split('.'); p[0]=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,' '); return p[0]+'.'+p[1]+' €'; }

var _TABLE_CSS='@page{size:A4 landscape;margin:12mm}*{box-sizing:border-box}html,body{margin:0;background:#fff}'
+'body{font-family:"Segoe UI",Arial,Helvetica,sans-serif;color:#1c2733;font-size:12px;-webkit-print-color-adjust:exact;print-color-adjust:exact;padding:8px}'
+'.rpt{max-width:272mm;margin:0 auto}'
+'.rhead{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:2px solid #15324e;padding-bottom:10px;margin-bottom:12px}'
+'.rt{font-size:18px;font-weight:800;color:#15324e}.rc{font-size:12px;color:#5b6b7a;margin-top:2px}'
+'.rd{text-align:right;font-size:11px;color:#5b6b7a}.rd b{display:block;color:#1c2733;font-size:12px;margin-top:2px}'
+'table{width:100%;border-collapse:collapse;font-size:11.5px}'
+'thead th{background:#15324e;color:#fff;text-align:left;padding:7px 9px;font-weight:600;font-size:11px}thead th.num{text-align:right}'
+'tbody td{padding:6px 9px;border-bottom:1px solid #dbe3ea;font-variant-numeric:tabular-nums}tbody td.num{text-align:right}'
+'tbody tr:nth-child(even){background:#fafcfc}'
+'tfoot td{padding:8px 9px;font-weight:800;color:#15324e;border-top:2px solid #15324e;font-size:12.5px}tfoot td.num{text-align:right;font-variant-numeric:tabular-nums}';

export function printInvoicesTable(list, cName, title){
  var comp=activeCompanyObj()||{};
  var now=new Date(); var dstr=('0'+now.getDate()).slice(-2)+'.'+('0'+(now.getMonth()+1)).slice(-2)+'.'+now.getFullYear();
  var numOf=function(i){ return parseInt(String(i.number||'').replace(/\D/g,''),10)||0; };
  var rows=list.slice().sort(function(a,b){ var d=String(a.issue_date||'').localeCompare(String(b.issue_date||'')); return d||(numOf(a)-numOf(b)); });
  var sub=0, vat=0, tot=0;
  var body=rows.map(function(i){
    var st=(typeof INV_STATUS!=='undefined' && INV_STATUS[i.status])?INV_STATUS[i.status][0]:'';
    sub+=Number(i.subtotal)||0; vat+=Number(i.vat_amount)||0; tot+=Number(i.total)||0;
    return '<tr><td>№ '+esc(i.number)+'</td><td>'+esc(cName(i.contact_id))+'</td>'
      +'<td>'+esc(i.issue_date?dfmt(i.issue_date):'—')+'</td>'
      +'<td>'+esc(i.due_date?dfmt(i.due_date):'—')+'</td>'
      +'<td class="num">'+_money(i.subtotal)+'</td>'
      +'<td class="num">'+_money(i.vat_amount)+'</td>'
      +'<td class="num">'+_money(i.total)+'</td>'
      +'<td>'+esc(st)+'</td></tr>';
  }).join('');
  var html='<!DOCTYPE html><html lang="bg"><head><meta charset="utf-8"><title>'+esc(title)+'</title><style>'+_TABLE_CSS+'</style></head><body>'
    +'<div class="rpt">'
    +'<div class="rhead"><div><div class="rt">'+esc(title)+'</div><div class="rc">'+esc(comp.name||'')+'</div></div><div class="rd">Изготвено на<b>'+dstr+' г.</b></div></div>'
    +'<table><thead><tr><th>№ Фактура</th><th>Клиент</th><th>Издадена</th><th>Падеж</th><th class="num">Основа</th><th class="num">ДДС</th><th class="num">Общо</th><th>Статус</th></tr></thead>'
    +'<tbody>'+body+'</tbody>'
    +'<tfoot><tr><td colspan="4">Общо ('+rows.length+' бр.)</td><td class="num">'+_money(sub)+'</td><td class="num">'+_money(vat)+'</td><td class="num">'+_money(tot)+'</td><td></td></tr></tfoot>'
    +'</table></div></body></html>';
  printHTML(html);
}

export function printInvoice(inv, contacts, opts) {
  opts = opts || {};
  const docLabel = opts.label || 'ФАКТУРА';
  const showTaxNote = opts.taxNote !== false;
  const company = activeCompanyObj() || {};
  const client = (contacts || contactsCache()).find((c) => c.id === inv.contact_id) || {};
  let area = document.getElementById('print-area');
  if (!area) { area = el('div', { id: 'print-area' }); document.body.appendChild(area); }
  clear(area);

  // Колона „Код" — само ако поне един ред е с код на артикул (както в PDF-а).
  const hasCode = (inv.items || []).some((it) => String(it.code || '').trim());
  const itemsRows = (inv.items || []).map((it, i) => el('tr', {},
    el('td', { text: String(i + 1) }), hasCode ? el('td', { text: String(it.code || '') }) : null, el('td', { text: it.description }),
    // Мярката на реда (Промени 16.10, т. 3й) — както в PDF-а.
    el('td', { text: String(it.unit || '') }),
    el('td', { class: 'r', text: String(it.quantity) }),
    el('td', { class: 'r', text: money(it.unit_price, inv.currency) }),
    el('td', { class: 'r', text: money((Number(it.quantity) || 0) * (Number(it.unit_price) || 0), inv.currency) })
  ));

  const partyBlock = (title, o, extra) => el('div', {},
    el('div', { class: 'ttl', text: title }),
    el('div', { style: 'font-weight:700;font-size:15px', text: o.name || '' }),
    o.eik ? el('div', { text: 'ЕИК: ' + o.eik }) : null,
    (o.vat_number) ? el('div', { text: 'ДДС №: ' + o.vat_number }) : null,
    (o.city || o.address) ? el('div', { text: [o.city, o.address].filter(Boolean).join(', ') }) : null,
    o.mol ? el('div', { text: 'МОЛ: ' + o.mol }) : null,
    extra || null
  );

  area.appendChild(el('div', { class: 'inv' },
    el('div', { class: 'inv-top' },
      el('div', { class: 'firm' }, el('h2', { text: company.name || 'Фирма' }), el('div', { text: company.city || '' })),
      el('div', { class: 'meta' }, el('div', { class: 'big', text: docLabel }), el('div', { text: '№ ' + inv.number }), el('div', { text: 'Дата: ' + dfmt(inv.issue_date) }), inv.due_date ? el('div', { text: 'Падеж: ' + dfmt(inv.due_date) }) : null, el('div', { text: 'Място на издаване: ' + (company.city || 'София') }))
    ),
    el('div', { class: 'inv-parties' },
      partyBlock('Получател', client),
      partyBlock('Доставчик', company, company.iban ? el('div', { text: 'IBAN: ' + company.iban }) : null)
    ),
    el('table', {}, el('thead', {}, el('tr', {}, el('th', { text: '#' }), hasCode ? el('th', { text: 'Код' }) : null, el('th', { text: 'Описание' }), el('th', { text: 'Мярка' }), el('th', { class: 'r', text: 'Кол.' }), el('th', { class: 'r', text: 'Ед. цена' }), el('th', { class: 'r', text: 'Сума' }))), el('tbody', {}, ...itemsRows)),
    el('div', { class: 'inv-tot' },
      el('div', { class: 'l' }, el('span', { text: 'Данъчна основа' }), el('span', { text: money(inv.subtotal, inv.currency) })),
      el('div', { class: 'l' }, el('span', { text: 'ДДС ' + (inv.vat_rate || 0) + '%' }), el('span', { text: money(inv.vat_amount, inv.currency) })),
      el('div', { class: 'l g' }, el('span', { text: 'Общо за плащане' }), el('span', { text: money(inv.total, inv.currency) }))
    ),
    // Словом-ът е на евро; заварен документ в друга валута минава без него.
    (inv.currency || 'EUR') === 'EUR' ? el('div', { style: 'margin-top:6px;font-size:12px;font-style:italic' }, 'Словом: ' + amountInWords(inv.total)) : null,
    el('div', { class: 'inv-pay' },
      el('div', { text: 'Начин на плащане: ' + (inv.payment_method || 'По банков път') }),
      company.bank ? el('div', { text: 'Банка: ' + company.bank }) : null,
      company.iban ? el('div', { text: 'IBAN: ' + company.iban }) : null,
      inv.notes ? el('div', { style: 'margin-top:6px', text: 'Основание: ' + inv.notes }) : null,
      // Фактура без ДДС е длъжна да каже защо (чл. 114, ал. 1, т. 12 ЗДДС).
      ((Number(inv.vat_rate) || 0) === 0 && String(inv.vat_basis || '').trim()) ? el('div', { style: 'margin-top:6px', text: 'Основание за неначисляване на ДДС: ' + String(inv.vat_basis).trim() }) : null
    ),
    showTaxNote ? el('div', { class: 'inv-note', style: 'margin-top:10px;font-size:11px;color:#555' }, el('div', { text: 'Фактурата е валидна без подпис и печат съгласно чл. 6, ал. 1 от Закона за счетоводството, чл. 114 от ЗДДС и чл. 78 от ППЗДДС.' })) : null,
    // Подписите под СВОЯТА страна (01.09.2026): Получил вляво под
    // получателя, Съставил вдясно под доставчика — бяха наопаки.
    el('div', { class: 'inv-sign' }, el('div', { text: 'Получил: ……………………' }), el('div', { text: 'Съставил: ' + (inv.created_by_name || (state().user && state().user.name) || '') }))
  ));

  const after = () => { area.style.display = 'none'; window.removeEventListener('afterprint', after); };
  window.addEventListener('afterprint', after);
  area.style.display = 'block';
  setTimeout(() => window.print(), 60);
}

window.printInvoice = printInvoice;
